import React, { useEffect } from 'react';
import {Alert, Card, CardContent, Typography} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import Link from "@mui/material/Link";
import {alpha} from "@mui/material/styles";
import Div from "@jumbo/shared/Div";
import {ASSET_IMAGES} from "../../../utils/constants/paths";
import {getAssetPath} from "../../../utils/appHelpers";
import {Form, Formik} from "formik";
import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField';
import { LoadingButton } from '@mui/lab';
import { useNavigate, useParams } from "react-router-dom";
import useApp from 'app/hooks/useApp';
import { passwordReset, validateEmailToken } from 'backendServices/ApiCalls';
import {
    getPasswordResetErrorMessage,
    PASSWORD_POLICY_HELP,
    resetPasswordValidationSchema,
    validateResetLink,
} from './resetPasswordPolicy';

const ResetPassword = () => {
    var {companyName} = useApp();
    const {token,email} = useParams();
    const [validToken, setValidToken] = React.useState(false)
    const [isLoading, setIsLoading] = React.useState(true)
    const [resetError, setResetError] = React.useState("")
    const navigate = useNavigate();


    useEffect(() => {
        let active = true;

        setValidToken(false);
        setIsLoading(true);
        setResetError("");

        const settle = (isValid) => {
            if (!active) return;
            setValidToken(isValid);
            setIsLoading(false);
        };

        validateResetLink({
            token,
            email,
            validateToken: validateEmailToken,
            onValid: () => settle(true),
            onInvalid: () => settle(false),
        });

        return () => {
            active = false;
        };
    }, [email, token]);

    const showResetError = (responseOrError, setSubmitting) => {
        setResetError(getPasswordResetErrorMessage(responseOrError));
        setSubmitting(false);
    };

    const resetPassword = (email,password,setSubmitting) => {
        setResetError("");
        passwordReset(email,password,token, (response) => {
            if(response?.data?.status === "error")
            {
                showResetError(response, setSubmitting)
            }
            else if(response?.data?.status === "success")
            {
                navigate('/login')
            }
            else{
                showResetError(response, setSubmitting)
    
        }
        }, (error) => {
            showResetError(error, setSubmitting)
        })
        
    
    };
if(isLoading)
{
    return (
        <Div role="status" aria-live="polite" sx={{p: 4, textAlign: 'center'}}>
            Validating password reset link...
        </Div>
    )
}
    return (
        
        <Div sx={{
            flex: 1,
            flexWrap: 'wrap',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: theme => theme.spacing(4),
        }}>
            <Div sx={{mb: 3, display: 'inline-flex'}}>
                <Link href="#" underline="none" sx={{display: 'inline-flex'}}>
                    <img src={`${ASSET_IMAGES}/logo.png`} style={{width:'150px'}} alt={companyName} />
                </Link>
            </Div>
            <Card sx={{maxWidth: '100%', width: 360, mb: 4}}>
                <Div sx={{position: 'relative', height: '200px'}}>
                    <CardMedia
                        component="img"
                        alt="green iguana"
                        height="200"
                        image={getAssetPath(`${ASSET_IMAGES}/colin-watts.jpg`)}
                    />
                    <Div sx={{
                        flex: 1,
                        inset: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: theme => alpha(theme.palette.common.black, .5),
                        p: theme => theme.spacing(3),
                    }}>
                        <Typography
                            variant={"h2"}
                            sx={{
                                color: 'common.white',
                                fontSize: '1.5rem',
                                mb: 0
                            }}>
                            Reset Password
                        </Typography>
                    </Div>
                </Div>
                <CardContent>
            {
                validToken === true ? 
                (
<Formik
                        key={`${token}:${email}`}
                        validateOnChange={true}
                        initialValues={{
                            password: '',
                            confirmpassword: '',
                        }}
                        validationSchema={resetPasswordValidationSchema}
                        onSubmit={(data, {setSubmitting}) => {
                            setSubmitting(true);
                            resetPassword(email,data.password, setSubmitting);
                        }}
                    >
                        {({isSubmitting}) => (
                            <Form style={{textAlign: 'left'}} noValidate>

                                {resetError && (
                                    <Alert
                                        severity="error"
                                        role="alert"
                                        onClose={() => setResetError("")}
                                        sx={{mb: 3}}
                                    >
                                        {resetError}
                                    </Alert>
                                )}

                                <Div sx={{mt: 1, mb: 3}}>
                                    <JumboTextField
                                        fullWidth
                                        id="new-password"
                                        name="password"
                                        label="Password"
                                        type="password"
                                        autoComplete="new-password"
                                        required
                                        inputProps={{
                                            'aria-describedby': 'password-policy-help new-password-helper-text',
                                        }}
                                    />
                                    <Typography
                                        id="password-policy-help"
                                        variant="body2"
                                        sx={{mt: 1, color: 'text.secondary'}}
                                    >
                                        {PASSWORD_POLICY_HELP}
                                    </Typography>
                                </Div>

                                <Div sx={{mt: 1, mb: 3}}>
                                    <JumboTextField
                                        fullWidth
                                        id="new-password-confirmation"
                                        name="confirmpassword"
                                        label="Confirm Password"
                                        type="password"
                                        autoComplete="new-password"
                                        required
                                    />
                                </Div>

                                <LoadingButton
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    sx={{mb: 3}}
                                    loading={isSubmitting}
                                >Submit</LoadingButton>

                                

                            </Form>
                        )}
                    </Formik>
                ) :

                (
                    <Alert severity="error" role="alert">
                        Invalid password reset link.{' '}
                        <Link href="/forget-password">Request a new reset link.</Link>
                    </Alert>
                )
            }
                
                </CardContent>
            </Card>

        </Div>
    );
};

export default ResetPassword;
